import { Router } from '@angular/router';
import { PostApiService } from './../../dataservices/post-api.service';
/**
 * Angular imports.
 */
import { Injectable, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { FunCollectionService } from './../../common/common-functions/fun-collection.service';
import { GetService } from './../../dataservices/get.service';
import { MasterserviceService } from './../../dataservices/master-service/masterservice.service';

/**
 * Rxjs imports.
 */
import { Observable, Subscription } from 'rxjs';

/**
 * Modal imports.
 */
import { GenericResponse, SpecialityListData, MemberListData, CommunityMembersResponse } from './../../onboarding/interface/apiResponse.model';
import { CreateCommunity, Member, UpdateCommunity, UpdateCommunityMember } from './../../onboarding/interface/global.model';

/**
 * Constant imports.
 */
import { COMMUNITY_USER_TYPE, NUMBERS } from './../../constants/app.constants';

/**
 * Create Community Service.
 */
@Injectable({ providedIn: 'root' })
export class CreateCommunityService implements OnDestroy {

  /**
   * Unsubscribe the subscription.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Members api process flag.
   * Members suggestion api offset.
   * Members suggestion list.
   * Speciality suggestion list.
   */
  public membersApiInProcess = false;
  public membersSuggestionOffset = 0;
  public membersSuggestionList = [];
  public memberList = [];
  public specialitySuggestionList = [];
  public isCommunityButtonDisable = false;
  public loggedInUser: Member;
  /**
   * For disabling submit button while post request
   */
  public postSubmitting = NUMBERS.ZERO;
  public existingMembersSuggestionOffset = NUMBERS.ONE;
  public communityCount = NUMBERS.ZERO;
  public removeState = NUMBERS.ZERO;

  /**
   * Necessary instances requires.
   */
  constructor(
    private getSer: GetService,
    private fcs: FunCollectionService,
    private postService: PostApiService,
    private router: Router,
    private masterService: MasterserviceService
  ) {
    this.getLoggedInUserDetail();
  }

  /**
   * Get the preselected logged in user detail to add in the community.
   */
  getLoggedInUserDetail(): void {
    this.masterService.getProfile()
      .subscribe(res => {
        this.loggedInUser = {
          custom_id: res.data.profile.custom_id,
          chat_id: res.data.profile.chat_id,
          permission: res.data.profile.permission,
          first_name: res.data.profile.first_name,
          middle_name: res.data.profile.middle_name,
          last_name: res.data.profile.last_name,
          registered_name: res.data.profile.registered_name,
          connection_status: res.data.connection_status,
          is_call_allow: res.data.is_call_allow,
          associations: res.data.profile.permission,
          chat_allow: res.data.chat_allow,
          is_connect_enable: res.data.is_connect_enable,
          is_user_blocked: res.data.profile.is_user_blocked,
          profile_pic: res.data.profile.profile_pic_path,
          specialities: res.data.speciality,
          full_name: `${res.data.profile.first_name} ${res.data.profile.middle_name} ${res.data.profile.last_name}`,
          is_email: 0,
          is_community_member: 0
        };
      });
  }

  /**
   * get the community enable/disable flag.
   */
  communityDisableCheck(): void {
    const checkDisableSub = this.postService.getCommunityButtonStatus()
      .subscribe((res: boolean) => this.isCommunityButtonDisable = res);
    this.subscriptions.add(checkDisableSub);
  }

  /**
   * connection List.
   */
  connectionList(searchType, offset, isSuggestion, keyword, filter, callingFor, community_id?): void {
    this.membersApiInProcess = true;
    this.subscriptions.add(this.getSer.getAddMemberList(searchType, offset, isSuggestion, keyword, filter, '', community_id)
      .subscribe((data: MemberListData) => {
        this.membersApiInProcess = false;
        if (data.status == 1) {
          this.membersSuggestionOffset = data.data.offset;
          if (callingFor) {
            this.membersSuggestionList = data.data.members;
          } else {
            this.membersSuggestionList = this.membersSuggestionList.concat(data.data.members);
          }
        } else {
          this.fcs.errorHandeler(data);
        }
      }, err => {
        this.fcs.errorHandeler(err);
        this.membersApiInProcess = false;
      }));
  }
  /**
   * For existing member list
   */
  FetchMemberList(searchType: string, offset: number, isSuggestion: number, keyword: string, filter, callingFor: boolean, communityId?): void {
    this.membersApiInProcess = true;
    this.subscriptions.add(this.getSer.getCommunityMembers(keyword, communityId, offset, '')
      .subscribe((data: CommunityMembersResponse) => {
        this.membersApiInProcess = false;
        if (data.status === NUMBERS.ONE) {
          this.existingMembersSuggestionOffset = data.data.offset;
          if (callingFor) {
            this.memberList = data.data.members;
          } else {
            this.memberList = this.memberList.concat(data.data.members);
          }
        } else {
          this.fcs.errorHandeler(data);
        }
      }, err => {
        this.fcs.errorHandeler(err);
        this.membersApiInProcess = false;
      }));
  }

  /**
   * get Speciality List
   */
  getSpecialityList(): void {
    this.subscriptions.add(this.getSer.getClinicalspecialityList()
      .subscribe((data: SpecialityListData) => {
        if (data.status === 1) {
          this.specialitySuggestionList = data.data.speciality_list.map(obj => ({
            banner: obj.banner,
            isPrimary: obj.is_primary,
            isSelected: obj.is_selected,
            logo: obj.logo,
            id: obj.speciality_id,
            name: obj.speciality_name,
          }));
        } else {
          this.fcs.errorHandeler(data);
        }
      }, (err) => this.fcs.errorHandeler(err)));
  }

  /**
   * Reset the service values.
   */
  resetValues(): void {
    this.membersApiInProcess = false;
    this.membersSuggestionOffset = 0;
    this.membersSuggestionList = [];
    this.specialitySuggestionList = [];
  }

  /**
   * Create the community and redirect to the community list.
   */
  submitCommunity(form, specialties, members, banner): void {
    this.postService.setCommunityButtonStatus(true);
    this.postSubmitting = NUMBERS.ONE;
    const body: CreateCommunity = {
      banner,
      description: form.description,
      title: form.title,
      privacy: form.privacy,
      specialties: specialties.map(obj => obj.id),
      join_type: form.join_type,
      members: members.map(obj => ({ custom_id: obj.custom_id, type: (obj.custom_id === this.loggedInUser.custom_id) ? COMMUNITY_USER_TYPE.ADMIN : COMMUNITY_USER_TYPE.MEMBER }))
    };
    this.subscriptions.add(this.postService.createCommunity(body)
      .subscribe((res: GenericResponse) => {
        if (res.status === 1) {
          this.router.navigate(['/community/list']);
        } else {
          this.fcs.errorHandeler(res);
          this.postSubmitting = NUMBERS.ZERO;
        }
      }, err => {
        this.fcs.errorHandeler(err);
        this.postSubmitting = NUMBERS.ZERO;
      }));
  }
  /**
   * Update Community
  */
  updateCommunity(form, banner, specialties, communityId, fromEdit, fromCommunityDetail?): void {
    this.postService.setCommunityButtonStatus(true);
    const body: UpdateCommunity = {
      banner,
      description: form.description,
      title: form.title,
      privacy: form.privacy,
      specialties: specialties.map(obj => obj.id),
      join_type: form.join_type
    };
    this.subscriptions.add(this.postService.updateCommunity(communityId, body)
      .subscribe((res: GenericResponse) => {
        if (res.status === 1) {
          if (fromEdit) {
            if (!fromCommunityDetail) {
              setTimeout(() => {
                this.router.navigate(['/community/list']);
              }, 400);
            } else {
              setTimeout(() => {
                this.router.navigateByUrl(`community/detail/${communityId}`);
              }, 400);
            }
          }
        } else {
          this.fcs.errorHandeler(res);
        }
      }, err => this.fcs.errorHandeler(err)));
  }
  /**
   * Update Community Member
  */
  updateCommunityMember(members, communityId): Observable<GenericResponse> {
    this.postService.setCommunityButtonStatus(true);
    const body: UpdateCommunityMember = {
      members: members.map(obj => ({ custom_id: obj.custom_id, action: obj.action, type: obj.community_member_type ? obj.community_member_type : COMMUNITY_USER_TYPE.MEMBER }))
    };
    return this.postService.updateCommunityMember(communityId, body);
  }
  /**
   * Update Community
  */
  removeCommunityPic(form, banner, specialties, communityId): void {
    this.postService.setCommunityButtonStatus(true);
    const body: UpdateCommunity = {
      banner,
      description: form.description,
      title: form.title,
      privacy: form.privacy,
      specialties: specialties.map(obj => obj.id),
      join_type: form.join_type
    };
    this.subscriptions.add(this.postService.updateCommunity(communityId, body)
      .subscribe((res: GenericResponse) => {
        if (res.status === 1) {
          // No Code
        } else {
          this.fcs.errorHandeler(res);
        }
      }, err => this.fcs.errorHandeler(err)));
  }
  /**
   * Clear the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
    this.resetValues();
  }
}
